import React, { FC } from 'react';

import InformationList from '../../domain/InformationList';
import { PageTitle } from '../../case/PageTitle';
import { AdminWrapper } from '../../domain/AdminWrapper';
import IconInformation from '../../base/Icon/IconInformation';

const Information: FC = () => {
  return (
    <AdminWrapper>
      <PageTitle Icon={<IconInformation size={32} />}>お知らせ</PageTitle>
      <InformationList />
    </AdminWrapper>
  );
};

export default Information;
